import { doc, setDoc } from 'firebase/firestore';
import { ValidExportDateFormat } from '../../../utils/export';
import { userAsPromise } from '../../providers/userProvider';

/**
 * @description persists the users current activity setting
 * @param settings
 */
export const saveExportDateFormatSetting = async (
  setting: ValidExportDateFormat
): Promise<void> => {
  const user = await userAsPromise();

  return setDoc(
    doc(
      user.services.firestore,
      `userProfiles/${user.id}/settings/exportDateFormat`
    ),
    { value: setting },
    { merge: true }
  );
};
